import { CheckCircle, Clock, Warning } from "@phosphor-icons/react";

const MAP = {
  complete: {
    label: "Complete",
    style: () => ({ background: "var(--invert-bg)", color: "var(--invert-text)", border: "1px solid var(--invert-bg)" }),
    Icon: CheckCircle,
  },
  pending: {
    label: "Pending",
    style: () => ({ background: "transparent", color: "var(--text)", border: "1px solid var(--text)" }),
    Icon: Clock,
  },
  needs_verification: {
    label: "Confirming Receipt",
    style: () => ({ background: "transparent", color: "var(--text)", border: "1px dashed var(--text)" }),
    Icon: Warning,
  },
};

export default function StatusBadge({ status, testid }) {
  const s = MAP[status] || MAP.pending;
  const { Icon } = s;
  return (
    <span
      data-testid={testid || `status-badge-${status}`}
      className="inline-flex items-center gap-1.5 px-2.5 py-1 label"
      style={s.style()}
    >
      <Icon size={12} weight="bold" />
      {s.label}
    </span>
  );
}
